export const RmaMarketSymbolCodes = {
  CORN: 'C',
  CLASS_III_MILK: 'DA',
  SOYBEAN_MEAL: 'SM',
  LIVE_CATTLE: 'LE',
  FEEDER_CATTLE: 'GF',
} as const;

export type RmaMarketSymbolCodes =
  (typeof RmaMarketSymbolCodes)[keyof typeof RmaMarketSymbolCodes];
